function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgTvsEVideo = function SvgTvsEVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#TvsEVideo_svg__clip0_4871_58)",
    stroke: "#1A1D23",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.522 19.384c0 .565-.44 1.024-1.005 1.033H2.483c-.565 0-1.005-.468-1.005-1.033V6.012c0-.564.44-1.023 1.005-1.033h19.044c.564 0 1.004.469 1.004 1.033v13.372h-.01zM4.28 20.417v2.105M19.72 20.417v2.105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.093 1.478L12 4.988l4.907-3.51M19.02 14.917a2.765 2.765 0 01-2.802 2.688l-8.417.02a2.75 2.75 0 01-2.812-2.67V10.49A2.75 2.75 0 017.782 7.8l8.417-.02a2.75 2.75 0 012.812 2.67v4.466h.01z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "TvsEVideo_svg__clip0_4871_58"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 1)",
    d: "M0 0h22v22H0z"
  }))));
};
SvgTvsEVideo.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgTvsEVideo.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgTvsEVideo;